import React, { FC, useEffect, useState } from 'react';
import { AuthConsumer } from '../AuthProvider';
import SandBoxLogo from '../../../assets/SandBoxSystem@3x.png';
import Footer from '../../../assets/footer.jpg';
import 'material-icons/iconfont/material-icons.css';
import './Login.scss';
import { GetUsersCheckEmail } from '../../../types/schemaTypes';
import { GET_USERS_CHECK_EMAIL } from '../../../graphql/client/queries';
import { useQuery } from '@apollo/client/react';

const Login: FC = () => {
    localStorage.removeItem('carrierId');
    localStorage.removeItem('redirectbackto');
    const [email, setEmail] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [isEmailExists, setIsEmailExists] = useState(true);
    const [isEmailCheckCompleted, setIsEmailCheckCompleted] = useState(false);
    const [callbackError, setCallbackError] = useState<'state' | null>(() => {
        if (typeof window === 'undefined') return null;
        const params = new URLSearchParams(window.location.search);
        return params.get('callback_error') === 'state' ? 'state' : null;
    });

    useEffect(() => {
        if (callbackError && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.delete('callback_error');
            window.history.replaceState({}, '', url.pathname + url.search);
        }
    }, [callbackError]);

    const { data, loading } = useQuery<GetUsersCheckEmail>(GET_USERS_CHECK_EMAIL, {
        variables: { input: { emailAddress: searchEmail } },
        fetchPolicy: 'no-cache',
        skip: searchEmail === '',
    });

    useEffect(() => {
        if (data?.getUsersCheckEmail != null && searchEmail !== '') {
            setIsEmailCheckCompleted(true);
            const emailExists = data.getUsersCheckEmail.emailExists == null ? false : data.getUsersCheckEmail.emailExists;
            setIsEmailExists(emailExists);
        } else if (searchEmail === '') {
            setIsEmailCheckCompleted(false);
        }
    }, [data, searchEmail]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setIsEmailCheckCompleted(false);
            setSearchEmail(email);
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [email]);

    const onsubmitLogin = (userManager, e) => {
        e.preventDefault();
        if (email !== '' && isEmailCheckCompleted && isEmailExists) {
            userManager.signinRedirect({
                login_hint: email,
                prompt: 'login',
            });
        }
    };

    return (
        <AuthConsumer>
            {({ userManager }) => {
                return (
                    <div className="Login">
                        <div className="Login-Container">
                            <img
                                className="Login-Logo"
                                src={SandBoxLogo}
                                alt="Operations Portal Logo"
                                width="407"
                                height="78"
                            />
                            <form className="Login-Form" onSubmit={(event): void => onsubmitLogin(userManager, event)}>
                                <input
                                    autoFocus
                                    autoComplete="username"
                                    className="Login-Form-Email"
                                    type="email"
                                    placeholder="EMAIL"
                                    required
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />

                                {callbackError === 'state' && (
                                    <div className="email-not-exist-div">
                                        <label className="email-not-exist-lable" style={{ display: 'block' }}>
                                            Sign-in could not be completed. Open this app from the same URL you use to sign in (e.g. use https://opsportal-dev.ussilica.com for the whole sign-in, not localhost). Then try again.
                                        </label>
                                    </div>
                                )}
                                <div className="email-not-exist-div">
                                    {email != '' && isEmailCheckCompleted && !isEmailExists && (
                                        <label className="email-not-exist-lable">
                                            User account does not exist. Please contact customer service for assistance.
                                        </label>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="Login-Form-Button"
                                    disabled={email === '' || loading || !isEmailCheckCompleted || !isEmailExists}
                                >
                                    Login
                                </button>
                            </form>
                        </div>

                        <footer className="Login-Footer">
                            <img className="Login-Footer-Asset" src={Footer} alt="Workflow process" />
                            <div className="Login-Footer-Top" />
                            <div className="Login-Footer-Bottom" />
                        </footer>
                    </div>
                );
            }}
        </AuthConsumer>
    );
};

export default Login;
